<div mat-dialog-title>
  Integrantes
</div>
<mat-dialog-content>
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">

    <ng-container matColumnDef="titular">
      <th mat-header-cell *matHeaderCellDef>Tit.</th>
      <td mat-cell *matCellDef="let el">
        <mat-icon class="role-icon">{{ el.titular ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="encargado">
      <th mat-header-cell *matHeaderCellDef>Enc.</th>
      <td mat-cell *matCellDef="let el">
        <mat-icon class="role-icon">{{ el.encargado ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="suscrito">
      <th mat-header-cell *matHeaderCellDef>Sus.</th>
      <td mat-cell *matCellDef="let el">
        <mat-icon class="role-icon">{{ el.suscrito ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="nombre">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let element">{{ element.titulo }} {{ element.nombres }}</td>
    </ng-container>

    <ng-container matColumnDef="cargo">
      <th mat-header-cell *matHeaderCellDef>Cargo / Departamento</th>
      <td mat-cell *matCellDef="let element">{{ element.cargo }} {{ element.departamento }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="5">No hay integrantes</td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <span class="sgd-spacer"></span>
  <button mat-button (click)="close()">Cerrar</button>
</mat-dialog-actions>
